/* eslint-disable @typescript-eslint/no-unused-vars */
import { AxiosError } from "axios";

import useApi from "../api";
import { IApiResponse } from "../interfaces/IApiResponse";
import { useFormatMessage } from "../../utils/useFormatMessage";

export const useExternalService = () => {
  const api = useApi();
  const { errorMessage } = useFormatMessage();

  async function saveForm(model: any): Promise<IApiResponse<any | any>> {
    try {
      const formData = new FormData();
      formData.append("documento", model.documento);
      formData.append("nome", model.nome);
      formData.append("email", model.email);
      formData.append("pedido", model.pedido);
      formData.append("aconteceuPedido", model.aconteceuPedido);
      formData.append("telefone", model.telefone);
      formData.append("dataPedido", model.dataPedido);
      formData.append("numeroPedido", model.numeroPedido);
      formData.append("loja", model.loja);
      formData.append("descricaoPedido", model.descricaoPedido);
      formData.append("valor", model.valor);
      formData.append("faltaTrocaPedido", model.faltaTrocaPedido);
      if (model.fotoPedido) {
        formData.append("fotoPedido", model.fotoPedido); // Adiciona o arquivo fotoPedido
      }
      if (model.notaPedido) {
        formData.append("notaPedido", model.notaPedido); // Adiciona o arquivo notaPedido
      }
      formData.append("screenshot", model.screenshot); // Adiciona o arquivo screenshot
      const response = await api.post("/External/Save", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  async function saveFormMcFish(model: any): Promise<IApiResponse<any | any>> {
    try {
      const formData = new FormData();
      formData.append("documento", model.documento);
      formData.append("nome", model.nome);
      formData.append("email", model.email);  
      formData.append("telefone", model.telefone);
      formData.append("dataPedido", model.dataPedido);  
      formData.append("loja", model.loja);    
      formData.append("contato", model.contato);     
      formData.append("cidadeEstado", model.cidadeEstado);     
      formData.append("screenshot", model.screenshot); // Adiciona o arquivo screenshot
      const response = await api.post("/External/SaveMcFish", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return { status: response.status, data: response.data };
    } catch (error: AxiosError | any) {
      if (error.code === "ERR_NETWORK") {
        return {
          status: 503,
          data: errorMessage("ERR_NETWORK"),
        };
      }
      return {
        status: error.response.data.status,
        data: errorMessage(error.response.data),
      };
    }
  }

  return {
    saveForm,
    saveFormMcFish
  };
};
